import type { QueryClient } from '@tanstack/react-query';
import type { CorSelo } from '../../componentes/base';

export type Estado = 'pedido' | 'aprovado' | 'recusado' | 'cancelado';
export type Categoria = 'ferias' | 'atestado' | 'folga' | 'licenca' | 'outro';
export const CATEGORIAS: Categoria[] = ['ferias', 'atestado', 'folga', 'licenca', 'outro'];
export const ESTADOS: Estado[] = ['pedido', 'aprovado', 'recusado', 'cancelado'];
export const COR_ESTADO: Record<Estado, CorSelo> = { pedido: 'laranja', aprovado: 'verde', recusado: 'perigo', cancelado: 'neutro' };
export const COR_CATEGORIA: Record<Categoria, CorSelo> = { ferias: 'azul', atestado: 'roxo', folga: 'ciano', licenca: 'dourado', outro: 'neutro' };

export interface Tipo {
  id: string;
  nome: string;
  categoria: Categoria;
  remunerada: boolean;
  saldo_anual_dias: number | null;
  exige_aprovacao: boolean;
  contagem: 'corridos' | 'uteis';
  ativo: boolean;
  pedidos: number;
}

export interface Pedido {
  id: string;
  funcionario_id: string;
  funcionario_nome: string | null;
  tipo_id: string;
  tipo_nome: string;
  categoria: Categoria;
  remunerada: boolean;
  inicio: string;
  fim: string;
  dias: number;
  estado: Estado;
  observacao: string | null;
  motivo_decisao: string | null;
  decidido_por_nome: string | null;
  decidido_em: string | null;
  created_at: string;
  pode_decidir?: boolean;
  pode_cancelar?: boolean;
}

export interface ItemCalendario {
  id: string;
  funcionario_id: string;
  funcionario_nome: string | null;
  tipo_nome: string;
  categoria: Categoria;
  inicio: string;
  fim: string;
  dias: number;
  estado: 'pedido' | 'aprovado';
}

export interface SaldoTipo {
  tipo_id: string;
  tipo_nome: string;
  direito: number;
  ajustado: boolean;
  usado: number;
  pendente: number;
  disponivel: number;
}

export interface SaldoFuncionario {
  id: string;
  nome: string;
  ano: number;
  saldos: SaldoTipo[];
}

export interface LinhaFolha {
  funcionario_id: string;
  funcionario_nome: string | null;
  tipo_id: string;
  tipo_nome: string;
  remunerada: boolean;
  dias: number;
  periodos: string[];
}

export const invalidarAusencias = (qc: QueryClient) => qc.invalidateQueries({ queryKey: ['ausencias'] });
